import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import Select from 'antd/lib/select';
import Icon from 'antd/lib/icon';
import Spin from 'antd/lib/spin';
import { Link } from 'react-router';
import Popover from 'antd/lib/popover';
import { translate } from 'react-i18next';
import moment from 'moment';
import {
  gendersT,
  maritalStatusesT,
  educationT,
  socialStatusT,
  socialStatus,
  accountRolesT,
  accountRegistrationStatusesT,
} from '../../../../common/enums';
import rules from '../../../../common/rules/rules';
import accountRules from '../../../../common/rules/accountRules';
import { formatDateTime } from '../../../../common/utils/helpers';
import { rcFieldDecoratorOptions, createRcBackspaceHandler } from '../../../../common/utils/rcMask';
import Checkbox from 'antd/lib/checkbox';
import InputNumber from 'antd/lib/input-number';
import DatePicker from 'antd/lib/date-picker';
import { translation as sectorTranslation } from '../../../../common/enums/sector';
import  CommunicationHelper  from './CommunicationHelper';
import AdditionalEmailsHelper from './AdditionalEmailsHelper';
import AdditionalPhonesHelper from './AdditionalPhonesHelper';
import ObligationsHelper from './ObligationsHelper';
const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 9,
    },
    sm: {
      span: 12,
    },
  },
  wrapperCol: {
    xs: {
      span: 15,
    },
    sm: {
      span: 12,
    },
  },
};

const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 12,
      offset: 10,
    },
  },
};

const renderRating = account => {
  const rating = Number(account.rating);

  if (account.rating === null || typeof account.rating === 'undefined' || !Number.isFinite(rating)) {
    return <span>-</span>;
  }

  const normalizedRating = Math.min(Math.max((rating - 1) / 4, 0), 1);
  const ratingColor = `hsl(${Math.round(120 - (normalizedRating * 120))}, 70%, 38%)`;
  const formattedRating = rating.toLocaleString('sk-SK', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });

  return (
    <span>
      <span style={{ color: ratingColor, fontWeight: 600 }}>{formattedRating}</span>
      {account.ratingCalculatedAt && (
        <small style={{ marginLeft: 6, color: '#777' }}>({formatDateTime(account.ratingCalculatedAt)})</small>
      )}
    </span>
  );
};

class ComparisonPopOver extends Component {
  static proptypes = {
    comparison: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
  }

  render() {
    const { comparison, t } = this.props;

    if (!comparison) {
      return null;
    }

    const popoverTitle = (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1 style={{ fontSize: '1.1rem' }}>{comparison.label || '-'}</h1>
      </div>
    );

    const isOK = comparison.firstValue == comparison.secondValue;

    const popoverContent = (
      <dl className="id-card-info-dl">
      <dt>{t('Stav')}</dt>
      <dd>{isOK ? 'Hodnota sa zhoduje s údajom z biometrie: ' : 'Hodnota sa nezhoduje s údajom z biometrie: '}</dd>
      <dd>"{`${comparison.secondValue}`}"</dd>
    </dl>
    );

    return (
    <Popover content={popoverContent} title={popoverTitle} placement="rightBottom">
      {
        isOK ?
          <Icon type="check-circle" style={{ marginLeft: '1rem', color: 'limegreen' }}/>
          :
          <Icon type="close-circle" style={{ marginLeft: '1rem', color: 'red' }}/>
      }
    </Popover>
    )
  }
}

class PersonalNumberCheckInfoPopover extends Component {
  static proptypes = {
    account: PropTypes.object.isRequired,
    comparison: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
  }

  render() {
    const { account, comparison, t } = this.props;

    const personalNumberCheckPopoverTitle = (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1 style={{ fontSize: '1.1rem' }}>{'Kontrola rodného čísla'}</h1>
      </div>
    );

    const personalNumberCheckInfoPopoverContent = (

        <dl className="id-card-info-dl">
          <dt>{t('Kontrola duplicity')}</dt>
          <dd>{account.personalNumberCheck.length > 0 ? 'Rovnaké rodné číslo u iných klientov' : 'Nenašla sa zhoda u iných klientov'}</dd>
          <br/>
          {account.personalNumberCheck.length > 0 ? account.personalNumberCheck.map(acc =>
            <dd key={acc.id}>
              <Link
                  key={acc.id}
                  id={acc.id}
                  to={`/admin/accounts/${acc.id}/profile`}
              >
                {`${acc.firstName} ${acc.lastName}`}
              </Link>
              <br/>
            </dd>
          )
           : <dd></dd>}
          {comparison &&
            <span>
              <dt>{t('Porovnanie s biometriou')}</dt>
              <dd>
                {comparison.firstValue == comparison.secondValue ?
                  'Hodnota sa zhoduje s údajom z biometrie: ' : 'Hodnota sa nezhoduje s údajom z biometrie: '
                }
              </dd>
              <dd>{comparison.secondValue}</dd>
            </span>
          }
        </dl>
    );

    let personalNumberCheckPassed = account.personalNumberCheck.length == 0;
    if (comparison && comparison.firstValue != comparison.secondValue) {
      personalNumberCheckPassed = false;
    }

    return (
      <Popover content={personalNumberCheckInfoPopoverContent} title={personalNumberCheckPopoverTitle} placement="rightBottom">
        {personalNumberCheckPassed ?
          <Icon type="check-circle" style={{ marginLeft: '1rem', color: 'limegreen' }}/> :
          <Icon type="close-circle" style={{ marginLeft: '1rem', color: 'red' }}/>
        }
      </Popover>
    )
  }
}

class IdCardInfoPopover extends Component {
  static proptypes = {
    account: PropTypes.object.isRequired,
    comparison: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
    isFetchingIdCardInfo: PropTypes.bool.isRequired,
    updateIdCardInfo: PropTypes.func.isRequired,
  }

  renderIcon = (status) => {
    switch (status) {
      case 'GOOD':
        return <Icon type="check-circle" style={{ marginLeft: '1rem', color: 'limegreen' }}/>;
      case 'BAD':
        return <Icon type="close-circle" style={{ marginLeft: '1rem', color: 'red' }}/>;
      case 'NEUTRAL':
        return <Icon type="question-circle" style={{ marginLeft: '1rem', color: 'orange' }}/>;
      default:
        return <Icon type="question-circle" style={{ marginLeft: '1rem', color: 'orange' }}/>;;
    }
  }

  render() {
    const { account, comparison, t, isFetchingIdCardInfo, updateIdCardInfo } = this.props;
    const profileData = account.profileData;

    const idCardPopoverTitle = (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1 style={{ fontSize: '1.1rem' }}>{profileData.idCardNumber || '-'}</h1>
        <Button shape="circle" icon="reload" size="small" title="Obnoviť" onClick={updateIdCardInfo}/>
      </div>
    );

    const idCardInfoPopoverContent = (
      <Spin spinning={isFetchingIdCardInfo}>
        <dl className="id-card-info-dl">
          <dt>{t('Kontrola odcudzenia')}</dt>
          <dd>{account.idCardInfo ? account.idCardInfo.result : '-'}</dd>
          <dt>{t('Posledná aktualizácia')}</dt>
          <dd>{account.idCardInfo ? moment(account.idCardInfo.dateChecked).format('DD.MM.YYYY HH:mm') : '-'}</dd>
        {
          comparison &&
          <span>
            <dt>{t('Porovnanie s biometriou')}</dt>
              <dd>
                {comparison.firstValue == comparison.secondValue ?
                  'Hodnota sa zhoduje s údajom z biometrie: ' : 'Hodnota sa nezhoduje s údajom z biometrie: '
                }
              </dd>
              <dd>{comparison.secondValue}</dd>
          </span>
        }
        </dl>
      </Spin>
    );

    let status = account.idCardInfo ? account.idCardInfo.status : null;
    if (comparison && comparison.firstValue != comparison.secondValue) {
      status = 'BAD';
    }

    return (
      <Popover content={idCardInfoPopoverContent} title={idCardPopoverTitle} placement="rightBottom">
        { isFetchingIdCardInfo ?
          <Icon type="loading" style={{ marginLeft: '1rem' }} />
          :
          this.renderIcon(status)
        }
      </Popover>
    )
  }
}

const getEmployerVisibility = socialStatusValue => ({
  showEmployer: [
    socialStatus.EMPLOYED_INDEFINITE,
    socialStatus.EMPLOYED_DEFINITE,
    socialStatus.AGREEMENT_OTHER,
  ].includes(socialStatusValue),
  showCompanyName: [socialStatus.SELF_EMPLOYED, socialStatus.OWN_BUSINESS_INCOME].includes(socialStatusValue),
});

class DebtorProfile extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    account: PropTypes.object.isRequired,
    isEditable: PropTypes.bool.isRequired,
    form: PropTypes.object.isRequired,
    isFetchingIdCardInfo: PropTypes.bool.isRequired,
    updateIdCardInfo: PropTypes.func.isRequired,
    isCallCentrum: PropTypes.bool.isRequired,
  };

  state = {
    ...getEmployerVisibility(this.props.account.profileData && this.props.account.profileData.socialStatus),
    currentEmployer1: this.props.account.employersData && this.props.account.employersData.employer1 ? this.props.account.employersData.employer1.currentEmployer : false,
    currentEmployer2: this.props.account.employersData && this.props.account.employersData.employer2 ? this.props.account.employersData.employer2.currentEmployer : false,
  };

  componentDidUpdate(prevProps) {
    const prevSocialStatus = prevProps.account.profileData && prevProps.account.profileData.socialStatus;
    const currentSocialStatus = this.props.account.profileData && this.props.account.profileData.socialStatus;

    if (prevSocialStatus !== currentSocialStatus) {
      this.setState(getEmployerVisibility(currentSocialStatus));
    }
  }

  handleSocialStatusChange = value => {
    this.setState(getEmployerVisibility(value));
  };

  renderEmployersForm = (employers) => {
    return
  }


  handleCurrentEmployerChange = (id, event) => {

    const { setFieldsValue, getFieldValue } = this.props.form

    let employer1 = getFieldValue("employer1")
    let employer2 = getFieldValue("employer2")


    if (event.target.checked == true) {
      if (id == 1) {
        employer1.currentEmployer = true
        employer2.currentEmployer = false
        this.setState({
          ...this.state,
          currentEmployer1: true,
          currentEmployer2: false
        })

      } else {
        employer1.currentEmployer = false
        employer2.currentEmployer = true
        this.setState({
          ...this.state,
          currentEmployer1: false,
          currentEmployer2: true
        })
      }
    } else {
 employer1.currentEmployer = false
        employer2.currentEmployer = false
        this.setState({
          ...this.state,
          currentEmployer1: false,
          currentEmployer2: false
        })
    }

      setFieldsValue({
        employer1: { ...employer1 },
      })
      setFieldsValue({
        employer2: { ...employer2 },
      })
 }

  getBiometricsDataComparison = () => {
    const { account, t } = this.props;
    const profileData = account.profileData;

    let biometricsDataComparison = {};

    if (account.verificationResult && account.verificationResult.data) {
      const verificationData = account.verificationResult.data;

      biometricsDataComparison = {
        name: {
          firstValue: account.nameFirst,
          secondValue: verificationData.name,
          label: t('Meno'),
        },
        surname: {
          firstValue: account.nameLast,
          secondValue: verificationData.surname,
          label: t('Priezvisko'),
        },
        birth_surname: {
          firstValue: account.birthLastName,
          secondValue: verificationData.birth_surname,
          label: t('Rodné priezvisko'),
        },
        street: {
          firstValue: profileData.address.street,
          secondValue: verificationData.street,
          label: t('Ulica a číslo'),
        },
        city: {
          firstValue: profileData.address.city,
          secondValue: verificationData.address ? verificationData.address.split(',')[0] : '',
          label: t('Mesto'),
        },
        gender: {
          firstValue: gendersT[profileData.gender],
          secondValue: gendersT[verificationData.sex === 'M' ? 'MALE' : 'FEMALE'],
          label: t('Pohlavie'),
        },
        birth_number: {
          firstValue: profileData.personalNumber,
          secondValue: verificationData.birth_number ? verificationData.birth_number.replace('/', '') : '',
          label: t('Rodné číslo'),
        },
        idCardNumber: {
          firstValue: profileData.idCardNumber,
          secondValue: verificationData.number,
          label: t('Číslo občianskeho preukazu'),
        }
      }

    }

    return biometricsDataComparison;
  }

  render() {
    const { account, isEditable, form, t, isFetchingIdCardInfo, updateIdCardInfo, isCallCentrum } = this.props;
    const { getFieldDecorator } = form;
    const { showEmployer, currentEmployer1, currentEmployer2} = this.state;
    const profileData = account.profileData;
    const employersData = account.employersData

    if (!profileData || !profileData.address || !employersData || !employersData.employer1 || !employersData.employer2) {
      return <div>Loading profile data...</div>;
    }

    let contactsItemLayout = {...formItemLayout}

    if (!isEditable) {
      contactsItemLayout.labelCol = {
        ...formItemLayout.labelCol,
        style: {
          lineHeight: '19px'
        }
      }
    }

    const biometricsDataComparison = this.getBiometricsDataComparison();

    return (
      <div>
        <Form.Item {...formItemLayout} label={t('Komunikácia')}>
          <CommunicationHelper account={account}></CommunicationHelper>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Známka')}>
          {renderRating(account)}
        </Form.Item>

        <Form.Item {...tailFormItemLayout}>
          <h3>{t('Osobné údaje')}</h3>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Meno')}>
          {isEditable && !isCallCentrum ? (
              getFieldDecorator('nameFirst', {
                rules: rules.required,
                initialValue: account.nameFirst,
              })(<Input size="default" placeholder={t('Meno')} autoFocus />)
            ) : (
              <div>
                <span>{account.nameFirst}</span>
                <ComparisonPopOver
                  comparison={biometricsDataComparison.name}
                  t={t}
                />
              </div>
            )
          }
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Priezvisko')}>
          {isEditable && !isCallCentrum ? (
              getFieldDecorator('nameLast', {
                rules: rules.required,
                initialValue: account.nameLast,
              })(<Input size="default" placeholder={t('Priezvisko')} />)
            ) : (
              <div>
                <span>{account.nameLast}</span>
                <ComparisonPopOver
                  comparison={biometricsDataComparison.surname}
                  t={t}
                />
              </div>
            )
          }
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Rodné priezvisko')}>
          {isEditable && !isCallCentrum ? (
              getFieldDecorator('birthLastName', {
                rules: [],
                initialValue: account.birthLastName,
              })(<Input size="default" placeholder={t('Rodné priezvisko')} />)
            ) : (
              <div>
                <span>{account.birthLastName}</span>
                <ComparisonPopOver
                  comparison={biometricsDataComparison.birth_surname}
                  t={t}
                />
              </div>
            )
          }
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Rola')}>
          <span>{accountRolesT[account.role]}</span>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Stav registrácie')}>
          <span>{accountRegistrationStatusesT[account.registrationStatus]}</span>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Číslo dlžníka')}>
          <span>{account.accountNumber}</span>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Deaktivovaný')}>
          {isEditable && !isCallCentrum ? (
            getFieldDecorator('locked', {
              rules: rules.required,
              initialValue: account.locked,
            })(<Checkbox defaultChecked={account.locked} />)
          ) : (
            account.locked ? t('Áno') : t('Nie')
          )}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Dátum vytvorenia')}>
          <span>{formatDateTime(account.createdAt)}</span>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Dátum úpravy')}>
          <span>{formatDateTime(account.updatedAt)}</span>
        </Form.Item>

        <Form.Item {...tailFormItemLayout}>
          <h3>{t('Kontaktné údaje')}</h3>
        </Form.Item>

        <Form.Item {...contactsItemLayout} label={t('E-mail')}>
            {!isEditable && <span style={{ display: 'block', lineHeight: '19px'}}>{account.email != "" ? account.email : profileData.email}</span>}
            {isEditable && (
              getFieldDecorator('email', {
                rules: accountRules.email,
                initialValue: account.email != "" ? account.email : profileData.email,
              })(<Input size="default" placeholder={t('E-mail')} type="email" />)
            )}

            {!isEditable && <Checkbox checked={profileData.emailNotContact} disabled >{t('Nekontaktovať')}</Checkbox>}
            {isEditable && getFieldDecorator('emailNotContact', { initialValue: profileData.emailNotContact, valuePropName: 'checked' })(
                <Checkbox style={{ marginRight: 10 }}>{t('Nekontaktovať')}</Checkbox>
            )}

            {!isEditable && <Checkbox checked={profileData.emailAnotherPerson} disabled >{t('Iná osoba')}</Checkbox>}
            {isEditable && getFieldDecorator('emailAnotherPerson', { initialValue: profileData.emailAnotherPerson, valuePropName: 'checked' })(
                <Checkbox style={{ marginRight: 10 }}>{t('Iná osoba')}</Checkbox>
            )}

            {!isEditable && <Checkbox checked={profileData.emailUndeliverable} disabled >{t('Nedoručiteľný')}</Checkbox>}
            {isEditable && getFieldDecorator('emailUndeliverable', { initialValue: profileData.emailUndeliverable, valuePropName: 'checked' })(
                <Checkbox>{t('Nedoručiteľný')}</Checkbox>
            )}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Email overený')}>
          { account.emailConfirmed ? t('Áno') : t('Nie')}
        </Form.Item>

        <AdditionalEmailsHelper account={account} isEditable={isEditable} isCallCentrum={isCallCentrum} form={form}></AdditionalEmailsHelper>

        <Form.Item {...contactsItemLayout} label={t('Telefónne číslo')}>
          {!isEditable && <span style={{ display: 'block', lineHeight: 'initial'}}>{profileData.phone}</span>}
          {isEditable &&
            getFieldDecorator('phone', {
              rules: accountRules.telephoneNumber,
              initialValue: profileData.phone,
            })(<Input size="default" placeholder={t('090x xxx xxx')} />)}

            {!isEditable && <Checkbox checked={profileData.phoneActive} disabled>{t('Aktívne')}</Checkbox>}
            {isEditable && getFieldDecorator('phoneActive', { initialValue: profileData.phoneActive, valuePropName: 'checked' })(
                <Checkbox style={{ marginRight: 10 }}>{t('Aktívne')}</Checkbox>
            )}

            {!isEditable && <Checkbox checked={profileData.phonePrefered} disabled >{t('Preferované')}</Checkbox>}
            {isEditable && getFieldDecorator('phonePrefered', { initialValue: profileData.phonePrefered, valuePropName: 'checked' })(
                <Checkbox style={{ marginRight: 10 }}>{t('Preferované')}</Checkbox>
            )}

            {!isEditable && <Checkbox checked={profileData.phoneChecked} disabled >{t('Overené')}</Checkbox>}
            {isEditable && getFieldDecorator('phoneChecked', { initialValue: profileData.phoneChecked, valuePropName: 'checked' })(
                <Checkbox style={{ marginRight: 10 }}>{t('Overené')}</Checkbox>
            )}

            {!isEditable && <Checkbox checked={profileData.phoneNotContact} disabled >{t('Nekontaktovať')}</Checkbox>}
            {isEditable && getFieldDecorator('phoneNotContact', { initialValue: profileData.phoneNotContact, valuePropName: 'checked' })(
                <Checkbox style={{ marginRight: 10 }}>{t('Nekontaktovať')}</Checkbox>
            )}

            {!isEditable && <Checkbox checked={profileData.phoneAnotherPerson} disabled >{t('Iná osoba')}</Checkbox>}
            {isEditable && getFieldDecorator('phoneAnotherPerson', { initialValue: profileData.phoneAnotherPerson, valuePropName: 'checked' })(
                <Checkbox>{t('Iná osoba')}</Checkbox>
            )}
        </Form.Item>

        <AdditionalPhonesHelper account={account} isEditable={isEditable} isCallCentrum={isCallCentrum} form={form}></AdditionalPhonesHelper>

        <Form.Item {...tailFormItemLayout}>
          <h4>{t('Adresa')}</h4>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Ulica a číslo')}>
          {!isEditable &&
            <div>
              <span>{profileData.address.street}</span>
              <ComparisonPopOver
                  comparison={biometricsDataComparison.street}
                  t={t}
                />
            </div>
          }
          {isEditable &&
            getFieldDecorator('address.street', {
              initialValue: profileData.address.street,
            })(<Input size="default" placeholder={t('Ulica a číslo')} />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Mesto')}>
          {!isEditable &&
            <div>
              <span>{profileData.address.city}</span>
              <ComparisonPopOver
                comparison={biometricsDataComparison.city}
                t={t}
              />
            </div>}
          {isEditable &&
            getFieldDecorator('address.city', {
              initialValue: profileData.address.city,
            })(<Input size="default" placeholder={t('Mesto')} />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('PSČ')}>
          {!isEditable && <div> <span>{profileData.address.zip}</span><br/></div>}
          {isEditable &&
            getFieldDecorator('address.zip', {
              rules: [...rules.required, ...accountRules.zip],
              initialValue: profileData.address.zip,
            })(<Input size="default" placeholder={t('PSČ')} />)}

          {!isEditable && <Checkbox disabled={true} checked={profileData.address.mailReturned} >{t('Vrátená pošta')}</Checkbox>}
          {isEditable &&
            getFieldDecorator('address.mailReturned', {
              initialValue: profileData.address.mailReturned, valuePropName: 'checked'
            })(<Checkbox style={{ marginRight: 10 }} checked={profileData.address.mailReturned} >{t('Vrátená pošta')}</Checkbox>)}

          {!isEditable && <Checkbox disabled={true} checked={profileData.address.verifiedAddress} >{t('Overená adresa')}</Checkbox>}
          {isEditable &&
            getFieldDecorator('address.verifiedAddress', {
              initialValue: profileData.address.verifiedAddress, valuePropName: 'checked'
            })(<Checkbox checked={profileData.address.verifiedAddress} >{t('Overená adresa')}</Checkbox>)}

        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Počet rokov bývania na adrese')}>
          {isEditable ? (
            getFieldDecorator('address.yearsAtAddress', {
              initialValue: profileData.address && profileData.address.yearsAtAddress,
            })(<InputNumber min={0} max={99} precision={0} />)
          ) : (
            <span>{profileData.address && profileData.address.yearsAtAddress}</span>
          )}
        </Form.Item>

        <Form.Item {...tailFormItemLayout}>
          <h4>{t('Doručovacia adresa')}</h4>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Ulica a číslo')}>
          {!isEditable && <span>{profileData.deliveryAddress && profileData.deliveryAddress.street}</span> }
          {isEditable &&
            getFieldDecorator('deliveryAddress.street', {
              initialValue: profileData.deliveryAddress && profileData.deliveryAddress.street,
            })(<Input size="default" placeholder={t('Ulica a číslo')} />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Mesto')}>
          {!isEditable && <span>{profileData.deliveryAddress && profileData.deliveryAddress.city}</span>}
          {isEditable &&
            getFieldDecorator('deliveryAddress.city', {
              initialValue: profileData.deliveryAddress && profileData.deliveryAddress.city,
            })(<Input size="default" placeholder={t('Mesto')} />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('PSČ')}>
          {!isEditable && <div><span>{profileData.deliveryAddress && profileData.deliveryAddress.zip}</span><br/></div>}
          {isEditable &&
            getFieldDecorator('deliveryAddress.zip', {
              rules: accountRules.zip,
              initialValue: profileData.deliveryAddress && profileData.deliveryAddress.zip,
            })(<Input size="default" placeholder={t('PSČ')} />)}

          {!isEditable && profileData.deliveryAddress && <Checkbox disabled={true}  checked={profileData.deliveryAddress.mailReturned} >{t('Vrátená pošta')}</Checkbox>}
          {isEditable && profileData.deliveryAddress &&
            getFieldDecorator('deliveryAddress.mailReturned', {
              initialValue: profileData.deliveryAddress && profileData.deliveryAddress.mailReturned, valuePropName: 'checked'
            })(<Checkbox style={{ marginRight: 10 }} checked={profileData.deliveryAddress.mailReturned} >{t('Vrátená pošta')}</Checkbox>)}

          {!isEditable && profileData.deliveryAddress && <Checkbox disabled={true} checked={profileData.deliveryAddress.verifiedAddress} >{t('Overená adresa')}</Checkbox>}
          {isEditable && profileData.deliveryAddress &&
            getFieldDecorator('deliveryAddress.verifiedAddress', {
              initialValue: profileData.deliveryAddress && profileData.deliveryAddress.verifiedAddress, valuePropName: 'checked'
            })(<Checkbox checked={profileData.deliveryAddress.verifiedAddress} >{t('Overená adresa')}</Checkbox>)}
        </Form.Item>

        <Form.Item {...tailFormItemLayout}>
          <h3>{t('Ostatné')}</h3>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Pohlavie')}>
          {isEditable && !isCallCentrum ? (
            getFieldDecorator('gender', { initialValue: profileData.gender })(
              <Select size="default" placeholder={t('Vyberte pohlavie')}>
                {Object.entries(gendersT).map(([key, value]) => (
                  <Option key={key} value={key}>
                    {value}
                  </Option>
                ))}
              </Select>
            )) : (
              <div>
                <span>{gendersT[profileData.gender]}</span>
                <ComparisonPopOver
                  comparison={biometricsDataComparison.gender}
                  t={t}
              />
              </div>
            )
          }
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Rodné číslo')}>
          {isEditable && !isCallCentrum ? (
              getFieldDecorator('personalNumber', {
                rules: accountRules.personalNumber,
                initialValue: profileData.personalNumber,
                ...rcFieldDecoratorOptions,
              })(<Input size="default" placeholder={t('rrmmddxxxx')} onKeyDown={createRcBackspaceHandler(form, 'personalNumber')} />)
            ) : (
              <div>
                <span>{profileData.personalNumber}</span>
                {
                  <PersonalNumberCheckInfoPopover
                    account={account}
                    comparison={biometricsDataComparison.birth_number}
                    t={t}
                  />
                }
              </div>
            )
          }
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Číslo OP')}>
          {isEditable && !isCallCentrum ? (
            getFieldDecorator('idCardNumber', {
              rules: accountRules.idCardNumber,
              initialValue: profileData.idCardNumber,
            })(<Input size="default" placeholder={t('Číslo OP')} />
            )) : (
              <div>
                <span>{profileData.idCardNumber}</span>
                <IdCardInfoPopover
                  account={account}
                  comparison={biometricsDataComparison.idCardNumber}
                  t={t}
                  isFetchingIdCardInfo={isFetchingIdCardInfo}
                  updateIdCardInfo={updateIdCardInfo}
                />
              </div>
            )
          }
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('IBAN')}>
          {isEditable && !isCallCentrum ? (
              getFieldDecorator('iban', {
                rules: accountRules.iban,
                initialValue: profileData.iban,
              })(<Input size="default" placeholder={t('IBAN')} />)
            ) : (
              <span>{profileData.iban}</span>
            )
          }
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Rodinný stav')}>
          {isEditable && !isCallCentrum ? (
              getFieldDecorator('maritalStatus', {
                initialValue: profileData.maritalStatus,
              })(
                <Select size="default" placeholder={t('Vyberte rodinný stav')}>
                  {Object.entries(maritalStatusesT).map(([key, value]) => (
                    <Option key={key} value={key}>
                      {value}
                    </Option>
                  ))}
                </Select>
            )) : (
              <span>{maritalStatusesT[profileData.maritalStatus]}</span>
            )
          }
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Počet detí')}>
          {isEditable && !isCallCentrum ? (
            getFieldDecorator('kids', { initialValue: profileData.kids })(
              <Input size="default" placeholder={t('Počet detí')} />
            )) : (
              <span>{profileData.kids}</span>
            )
          }
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Vzdelanie')}>
          {isEditable && !isCallCentrum ? (
              getFieldDecorator('education', {
                initialValue: profileData.education,
              })(
                <Select size="default" placeholder={t('Vyberte vzdelanie')}>
                  {Object.entries(educationT).map(([key, value]) => (
                    <Option key={key} value={key}>
                      {value}
                    </Option>
                  ))}
                </Select>
            )) : (
              <span>{educationT[profileData.education]}</span>
            )
          }
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Zdroj príjmu')}>
          {isEditable && !isCallCentrum ? (
            getFieldDecorator('socialStatus', {
              initialValue: profileData.socialStatus,
            })(
              <Select
                size="default"
                placeholder={t('Zdroj príjmu')}
                onChange={this.handleSocialStatusChange}
              >
                {Object.entries(socialStatusT).map(([key, value]) => (
                  <Option key={key} value={key}>
                    {value}
                  </Option>
                ))}
              </Select>
            )) : (
              <span>{socialStatusT[profileData.socialStatus]}</span>
            )
          }
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Príjem od')}>
          {isEditable ? (
            getFieldDecorator('incomeFrom', {
              initialValue: profileData.incomeFrom ? moment(profileData.incomeFrom) : null,
            })(<DatePicker format="DD.MM.YYYY" />)
          ) : (
            <span>{profileData.incomeFrom ? moment(profileData.incomeFrom).format('DD.MM.YYYY') : ''}</span>
          )}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Odvetvie')}>
          {isEditable ? (
            getFieldDecorator('sector', {
              initialValue: profileData.sector,
            })(
              <Select allowClear>
                {Object.entries(sectorTranslation).map(([key, label]) => (
                  <Select.Option key={key} value={Number(key)}>{label}</Select.Option>
                ))}
              </Select>
            )
          ) : (
            <span>{profileData.sector ? sectorTranslation[profileData.sector] : ''}</span>
          )}
        </Form.Item>

        <Form.Item {...tailFormItemLayout}>
          <h3>{t('Zamestnávatelia')}</h3>
        </Form.Item>

        <Form.Item {...tailFormItemLayout}>
          <h4>{t(`Zamestnávateľ č. 1`)}</h4>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t(this.state.showCompanyName ? 'Názov spoločnosti' : 'Názov zamestnávateľa')}>
          {isEditable ? (
            getFieldDecorator('employer1.name', {
              initialValue: employersData.employer1.name,
              rules: (this.state.showEmployer || this.state.showCompanyName) ? [{ required: true, message: t('Povinné pole') }] : [],
            })(<Input size="default" placeholder={t(this.state.showCompanyName ? 'Názov spoločnosti' : 'Názov zamestnávateľa')} />)
          ) : (
            <span>{employersData.employer1.name}</span>
          )}
        </Form.Item>
        <Form.Item {...formItemLayout} label={t('Ulica a číslo')}>
          {!isEditable && <span>{employersData.employer1.address.street}</span>}
          {isEditable &&
            getFieldDecorator('employer1.address.street', {
              initialValue: employersData.employer1.address.street,
            })(<Input size="default" placeholder={t('Ulica a číslo')} />)}
        </Form.Item>

              <Form.Item {...formItemLayout} label={t('Mesto')}>
                {!isEditable && <span>{employersData.employer1.address.city}</span>}
                {isEditable &&
                  getFieldDecorator('employer1.address.city', {
                    initialValue: employersData.employer1.address.city,
                  })(<Input size="default" placeholder={t('Mesto')} />)}
              </Form.Item>

              <Form.Item {...formItemLayout} label={t('PSČ')}>
                {!isEditable && <div> <span>{employersData.employer1.address.zip}</span><br /></div>}
                {isEditable &&
                  getFieldDecorator('employer1.address.zip', {
                    rules: [...accountRules.zip],
                    initialValue: employersData.employer1.address.zip,
                  })(<Input size="default" placeholder={t('PSČ')} />)}
              </Form.Item>
              <Form.Item {...formItemLayout} label={t('IČO')}>
                {!isEditable && <div> <span>{employersData.employer1.companyNumber}</span><br /></div>}
                {isEditable &&
                  getFieldDecorator('employer1.companyNumber', {
                    initialValue: employersData.employer1.companyNumber,
                  })(<Input size="default" placeholder={t('IČO')} />)}
              </Form.Item>
              <Form.Item {...formItemLayout} label={t('Telefónne číslo')}>
                {!isEditable && <div> <span>{employersData.employer1.phone}</span><br /></div>}
                {isEditable &&
                  getFieldDecorator('employer1.phone', {
              rules: [...accountRules.optionalTelephoneNumber],
                    initialValue: employersData.employer1.phone,
                  })(<Input size="default" placeholder={t('Telefónne číslo')} />)}
              </Form.Item>
              <Form.Item {...formItemLayout} label={t('Aktuálny zamestnávateľ')}>
          {!isEditable && <div> <span>{employersData.employer1.currentEmployer ? "Áno" : "Nie"}</span><br /></div>}
           {isEditable &&
                  getFieldDecorator('employer1.currentEmployer', {
                    initialValue: currentEmployer1,
                  })(<Checkbox checked={currentEmployer1} onChange={(e) => this.handleCurrentEmployerChange(1, e)}></Checkbox>)}
        </Form.Item>

        <Form.Item {...tailFormItemLayout}>
          <h4>{t(`Zamestnávateľ č. 2`)}</h4>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Názov zamestnávateľa')}>
          {isEditable ? (
            getFieldDecorator('employer2.name', {
              initialValue: employersData.employer2.name,
            })(<Input size="default" placeholder={t('Názov zamestnávateľa')} />)
          ) : (
            <span>{employersData.employer2.name}</span>
          )}
        </Form.Item>
        <Form.Item {...formItemLayout} label={t('Ulica a číslo')}>
          {!isEditable && <span>{employersData.employer2.address.street}</span>}
          {isEditable &&
            getFieldDecorator('employer2.address.street', {
              initialValue: employersData.employer2.address.street,
            })(<Input size="default" placeholder={t('Ulica a číslo')} />)}
        </Form.Item>

              <Form.Item {...formItemLayout} label={t('Mesto')}>
                {!isEditable && <span>{employersData.employer2.address.city}</span>}
                {isEditable &&
                  getFieldDecorator('employer2.address.city', {
                    initialValue: employersData.employer2.address.city,
                  })(<Input size="default" placeholder={t('Mesto')} />)}
              </Form.Item>

              <Form.Item {...formItemLayout} label={t('PSČ')}>
                {!isEditable && <div> <span>{employersData.employer2.address.zip}</span><br /></div>}
                {isEditable &&
                  getFieldDecorator('employer2.address.zip', {
                    rules: [...accountRules.zip],
                    initialValue: employersData.employer2.address.zip,
                  })(<Input size="default" placeholder={t('PSČ')} />)}
              </Form.Item>
              <Form.Item {...formItemLayout} label={t('IČO')}>
                {!isEditable && <div> <span>{employersData.employer2.companyNumber}</span><br /></div>}
                {isEditable &&
                  getFieldDecorator('employer2.companyNumber', {
                    initialValue: employersData.employer2.companyNumber,
                  })(<Input size="default" placeholder={t('IČO')} />)}
              </Form.Item>
              <Form.Item {...formItemLayout} label={t('Telefónne číslo')}>
                {!isEditable && <div> <span>{employersData.employer2.phone}</span><br /></div>}
                {isEditable &&
                  getFieldDecorator('employer2.phone', {
              rules: [...accountRules.optionalTelephoneNumber],
                    initialValue: employersData.employer2.phone,
                  })(<Input size="default" placeholder={t('Telefónne číslo')} />)}
              </Form.Item>
              <Form.Item {...formItemLayout} label={t('Aktuálny zamestnávateľ')}>
                {!isEditable && <div> <span>{employersData.employer2.currentEmployer?"Áno":"Nie"}</span><br /></div>}
                     {isEditable &&
                  getFieldDecorator('employer2.currentEmployer', {
                    initialValue: currentEmployer2,
                  })(<Checkbox checked={currentEmployer2} onChange={(e) => this.handleCurrentEmployerChange(2, e)}></Checkbox>)}
        </Form.Item>

        <Form.Item {...tailFormItemLayout}>
          <h3>{t('Záväzky')}</h3>
        </Form.Item>

        <ObligationsHelper account={account} isEditable={isEditable} isCallCentrum={isCallCentrum} form={form} />

        <Form.Item {...formItemLayout} label={t('Dlh na poistnom alebo daniach v EUR')}>
          {isEditable ? (
            getFieldDecorator('insuranceTaxDebt', {
              initialValue: profileData.insuranceTaxDebt,
            })(<InputNumber min={0} precision={0} />)
          ) : (
            <span>{profileData.insuranceTaxDebt}</span>
          )}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Priemerný mesačný príjem (čistý)')}>
          {isEditable && !isCallCentrum ? (
              getFieldDecorator('income.monthlyAvg', {
                initialValue: profileData.income.monthlyAvg,
              })(
                <Input
                  size="default"
                  placeholder={t('Priemerný mesačný príjem (čistý)')}
                  addonAfter="€"
                />
              )
            ) : (
              <span>{profileData.income.monthlyAvg} €</span>
            )
          }
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Približné mesačné náklady')}>
          {isEditable && !isCallCentrum ? (
              getFieldDecorator('costs.monthlyAvg', {
                initialValue: profileData.costs ? profileData.costs.monthlyAvg : 0,
              })(
                <Input size="default" placeholder={t('Približné mesačné náklady')} addonAfter="€" />
              )
            ) : (
              <span>{profileData.costs ? profileData.costs.monthlyAvg : 0} €</span>
            )
          }
        </Form.Item>

      </div>
    );
  }
}

export default translate()(DebtorProfile);



// WEBPACK FOOTER //
// ./src/features/account-management/components/profile/DebtorProfile.js